import { BuyBoxState } from '../types';

export const initialBuyBoxState: BuyBoxState = {};
